import { gql } from "@apollo/client";
import WorkerFields from "../fragments/worker-fragment";

export default gql`
  mutation verifyWorker($data: WorkerInput!) {
    verifyWorker(data: $data) {
      ...WorkerFields
    }
  }
  ${WorkerFields}
`;
